'use client';

import BaseModal from './BaseModal';
import Pricing from '@/components/anyvideo/pricing';

const PricingModal = ({ isOpen, onClose }) => {
  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      className="w-full max-w-6xl overflow-hidden rounded-2xl border border-[#333333]/30 bg-gradient-to-b from-black to-gray-900/95 shadow-2xl"
    >
      {/* 添加顶部装饰条 */}
      <div className="h-1 w-full bg-gradient-to-r from-[#8735D9] via-[#98c209] to-cyan-400" />

      {/* 内容区域 */}
      <div className="p-8">
        <Pricing />
      </div>

      {/* 添加底部装饰效果 */}
      <div className="pointer-events-none absolute inset-x-0 bottom-0 h-20 bg-gradient-to-t from-[#8735D9]/5 to-transparent" />
    </BaseModal>
  );
};

export default PricingModal;
